import Intercom from '@intercom/messenger-js-sdk';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormulaireCU from '../src/components/layouts/FormulaireCU';
import './App.css';
import InfoPopupCards from './components/layouts/InfoPopupCards';
import LogoVille from './components/layouts/LogoVille';

function App({ x_id_submit, TypeForm }) {
  Intercom({
    api_base: 'https://api-iam.intercom.io',
    app_id: 'l4blokpb',
    region: 'eu',
  });
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });

  return (
    <>
      <div className="App d-flex flex-column align-items-center justify-content-center position-relative">
        <LogoVille />
        <FormulaireCU x_id_submit={x_id_submit} TypeForm={TypeForm} />
        <InfoPopupCards />
        <ToastContainer
          position={toast.POSITION.BOTTOM_CENTER}
          theme="colored"
        />
        {/* {env.environnement === "test_local" && (
          <button
            className="btn btn-warning mt-4"
            onClick={() => {
              throw new Error("This is your first error!");
            }}
          >
            Break the world
          </button>
        )} */}
      </div>
    </>
  );
}

export default App;
